import { CurrencyFormatter } from '@packages/helpers';

export const currencyFormatter = new CurrencyFormatter({
	currency:     'THB',
	locale:       'th-TH',
	customSymbol: 'B ',
});